import React from 'react';
import Icon from '../primitives/Icon';
import {
  Card, CardHeader, CardTitle, CardDescription, CardAction, CardContent, CardFooter,
} from '../../components/ui/card';
import { cn } from '../../components/ui/cn';
import './blocks.css';

// Shared shell for every chat block: a shadcn Card with an icon tile, title,
// optional description, a right-aligned action slot (`badge`) and a muted
// footer. `flush` drops the content padding for edge-to-edge tables.
const Block = ({
  icon, title, description, badge, children, footer, style, variant, flush, className,
}) => (
  <Card className={cn('q-block', variant === 'plain' && 'q-block--plain', className)} style={style}>
    <CardHeader>
      {icon && (
        <span className="q-block__icon" aria-hidden>
          <Icon name={icon} size={16} />
        </span>
      )}
      <div className="ui-card-heading">
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </div>
      {badge && <CardAction>{badge}</CardAction>}
    </CardHeader>
    <CardContent className={cn(flush && 'q-block__content--flush')}>{children}</CardContent>
    {footer && <CardFooter>{footer}</CardFooter>}
  </Card>
);

export default Block;
